import { translate } from '@shakkerai/util-i18n';
import { config } from '@shakkerai/config';
import { MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX } from '@shakkerai/pro-models';

const isOverseas = config.env === 'aws';

export const resizeModeOption = {
  type: 'select',
  name: 'resizeMode',
  label: translate('cn_resize_mode'),
  defaultValue: '1',
  options: [
    {
      value: '0',
      label: translate('cn_resize_mode_stretch'),
    },
    {
      value: '1',
      label: translate('cn_resize_mode_crop'),
    },
    {
      value: '2',
      label: translate('cn_resize_mode_fill'),
    },
  ],
};

export const controlModeOption = {
  type: 'select',
  name: 'controlMode',
  label: translate('imgref_characteristcs_preference'),
  defaultValue: '0',
  options: [
    {
      value: '1',
      label: translate('cn_control_mode_1'),
    },
    {
      value: '0',
      label: translate('cn_control_mode_2'),
    },
    {
      value: '2',
      label: translate('cn_control_mode_3'),
    },
  ],
};

export const noPreprocessControlNetTypes = ['reference', 'face', 'ip_adapter', 'tile', 'revision', 'entity_control'];

const modelsMap = {
  22544: {
    name: 'control_v11p_sd15_normalbae',
    label: 'control_v11p_sd15_normalbae',
    value: 22544,
  },
  22545: {
    name: 'control_v11p_sd15_lineart',
    label: 'control_v11p_sd15_lineart',
    value: 22545,
  },
  22546: {
    name: 'control_v11p_sd15_openpose',
    label: 'control_v11p_sd15_openpose',
    value: 22546,
  },
  22547: {
    name: 'control_v11p_sd15_canny',
    label: 'control_v11p_sd15_canny',
    value: 22547,
  },
  22548: {
    name: 'control_v11p_sd15_seg',
    label: 'control_v11p_sd15_seg',
    value: 22548,
  },
  22549: {
    name: 'control_v11e_sd15_ip2p',
    label: 'control_v11e_sd15_ip2p',
    value: 22549,
  },
  22550: {
    name: 'control_v11p_sd15_softedge',
    label: 'control_v11p_sd15_softedge',
    value: 22550,
  },
  22551: {
    name: 'control_v11p_sd15_scribble',
    label: 'control_v11p_sd15_scribble',
    value: 22551,
  },
  22552: {
    name: 'control_v11f1e_sd15_tile',
    label: 'control_v11f1e_sd15_tile',
    value: 22552,
  },
  22553: {
    name: 'control_v11e_sd15_shuffle',
    label: 'control_v11e_sd15_shuffle',
    value: 22553,
  },
  22554: {
    name: 'control_v11p_sd15_mlsd',
    label: 'control_v11p_sd15_mlsd',
    value: 22554,
  },
  22555: {
    name: 'control_v11p_sd15s2_lineart_anime',
    label: 'control_v11p_sd15s2_lineart_anime',
    value: 22555,
  },
  23336: {
    name: 'control_v11f1p_sd15_depth',
    label: 'control_v11f1p_sd15_depth',
    value: 23336,
  },
  23337: {
    name: 'control_v11p_sd15_inpaint',
    label: 'control_v11p_sd15_inpaint',
    value: 23337,
  },
  23338: {
    name: 't2iadapter_canny_sd15v2',
    label: 't2iadapter_canny_sd15v2',
    value: 23338,
  },
  23339: {
    name: 't2iadapter_depth_sd15v2',
    label: 't2iadapter_depth_sd15v2',
    value: 23339,
  },
  23340: {
    name: 't2iadapter_canny_sd14v1',
    label: 't2iadapter_canny_sd14v1',
    value: 23340,
  },
  23341: {
    name: 't2iadapter_color_sd14v1',
    label: 't2iadapter_color_sd14v1',
    value: 23341,
  },
  23342: {
    name: 't2iadapter_depth_sd14v1',
    label: 't2iadapter_depth_sd14v1',
    value: 23342,
  },
  23343: {
    name: 't2iadapter_keypose_sd14v1',
    label: 't2iadapter_keypose_sd14v1',
    value: 23343,
  },
  23344: {
    name: 't2iadapter_openpose_sd14v1',
    label: 't2iadapter_openpose_sd14v1',
    value: 23344,
  },
  23345: {
    name: 't2iadapter_seg_sd14v1',
    label: 't2iadapter_seg_sd14v1',
    value: 23345,
  },
  23346: {
    name: 't2iadapter_sketch_sd14v1',
    label: 't2iadapter_sketch_sd14v1',
    value: 23346,
  },
  23347: {
    name: 't2iadapter_sketch_sd15v2',
    label: 't2iadapter_sketch_sd15v2',
    value: 23347,
  },
  23348: {
    name: 't2iadapter_style_sd14v1',
    label: 't2iadapter_style_sd14v1',
    value: 23348,
  },
  23349: {
    name: 't2iadapter_zoedepth_sd15v1',
    label: 't2iadapter_zoedepth_sd15v1',
    value: 23349,
  },
  24821: {
    name: 'control_v1u_sd15_illumination',
    label: 'control_v1u_sd15_illumination',
    value: 24821,
  },
  28149: {
    name: 'control_v1p_sd15_qrcode_monster',
    label: 'control_v1p_sd15_qrcode_monster',
    value: 28149,
  },
  97052: {
    name: 't2i-adapter_xl_sketch',
    label: 't2i-adapter_xl_sketch',
    value: 97052,
  },
  97053: {
    name: 't2i-adapter_diffusers_xl_depth_zoe',
    label: 't2i-adapter_diffusers_xl_depth_zoe',
    value: 97053,
  },
  97054: {
    name: 'kohya_controllllite_xl_blur_anime',
    label: 'kohya_controllllite_xl_blur_anime',
    value: 97054,
  },
  97055: {
    name: 'sai_xl_canny_128lora',
    label: 'sai_xl_canny_128lora',
    value: 97055,
  },
  97056: {
    name: 'sai_xl_depth_128lora',
    label: 'sai_xl_depth_128lora',
    value: 97056,
  },
  97057: {
    name: 'ip-adapter_sd15',
    label: 'ip-adapter_sd15',
    value: 97057,
  },
  97058: {
    name: 'kohya_controllllite_xl_openpose_anime_v2',
    label: 'kohya_controllllite_xl_openpose_anime_v2',
    value: 97058,
  },
  97059: {
    name: 'sai_xl_sketch_256lora',
    label: 'sai_xl_sketch_256lora',
    value: 97059,
  },
  97060: {
    name: 'sai_xl_canny_256lora',
    label: 'sai_xl_canny_256lora',
    value: 97060,
  },
  97061: {
    name: 'diffusers_xl_canny_mid',
    label: 'diffusers_xl_canny_mid',
    value: 97061,
  },
  97062: {
    name: 't2i-adapter_diffusers_xl_depth_midas',
    label: 't2i-adapter_diffusers_xl_depth_midas',
    value: 97062,
  },
  97063: {
    name: 'kohya_controllllite_xl_openpose_anime',
    label: 'kohya_controllllite_xl_openpose_anime',
    value: 97063,
  },
  97064: {
    name: 'diffusers_xl_depth_mid',
    label: 'diffusers_xl_depth_mid',
    value: 97064,
  },
  97065: {
    name: 't2i-adapter_diffusers_xl_lineart',
    label: 't2i-adapter_diffusers_xl_lineart',
    value: 97065,
  },
  97066: {
    name: 'kohya_controllllite_xl_scribble_anime',
    label: 'kohya_controllllite_xl_scribble_anime',
    value: 97066,
  },
  97067: {
    name: 'sargezt_xl_softedge',
    label: 'sargezt_xl_softedge',
    value: 97067,
  },
  97068: {
    name: 'diffusers_xl_canny_small',
    label: 'diffusers_xl_canny_small',
    value: 97068,
  },
  97069: {
    name: 'thibaud_xl_openpose_256lora',
    label: 'thibaud_xl_openpose_256lora',
    value: 97069,
  },
  97070: {
    name: 'diffusers_xl_canny_full',
    label: 'diffusers_xl_canny_full',
    value: 97070,
  },
  97071: {
    name: 'ip-adapter_xl',
    label: 'ip-adapter_xl',
    value: 97071,
  },
  97072: {
    name: 'kohya_controllllite_xl_canny_anime',
    label: 'kohya_controllllite_xl_canny_anime',
    value: 97072,
  },
  97073: {
    name: 'sai_xl_sketch_128lora',
    label: 'sai_xl_sketch_128lora',
    value: 97073,
  },
  97074: {
    name: 't2i-adapter_xl_openpose',
    label: 't2i-adapter_xl_openpose',
    value: 97074,
  },
  97075: {
    name: 'sai_xl_recolor_128lora',
    label: 'sai_xl_recolor_128lora',
    value: 97075,
  },
  97076: {
    name: 'sai_xl_depth_256lora',
    label: 'sai_xl_depth_256lora',
    value: 97076,
  },
  97077: {
    name: 'kohya_controllllite_xl_canny',
    label: 'kohya_controllllite_xl_canny',
    value: 97077,
  },
  97078: {
    name: 'sargezt_xl_depth_zeed',
    label: 'sargezt_xl_depth_zeed',
    value: 97078,
  },
  97079: {
    name: 'sargezt_xl_depth',
    label: 'sargezt_xl_depth',
    value: 97079,
  },
  97080: {
    name: 'kohya_controllllite_xl_blur_anime_beta',
    label: 'kohya_controllllite_xl_blur_anime_beta',
    value: 97080,
  },
  97081: {
    name: 'kohya_controllllite_xl_depth_anime',
    label: 'kohya_controllllite_xl_depth_anime',
    value: 97081,
  },
  97082: {
    name: 'ioclab_sd15_recolor',
    label: 'ioclab_sd15_recolor',
    value: 97082,
  },
  97083: {
    name: 't2i-adapter_diffusers_xl_canny',
    label: 't2i-adapter_diffusers_xl_canny',
    value: 97083,
  },
  97084: {
    name: 't2i-adapter_diffusers_xl_sketch',
    label: 't2i-adapter_diffusers_xl_sketch',
    value: 97084,
  },
  97086: {
    name: 'kohya_controllllite_xl_depth',
    label: 'kohya_controllllite_xl_depth',
    value: 97086,
  },
  97087: {
    name: 't2i-adapter_diffusers_xl_openpose',
    label: 't2i-adapter_diffusers_xl_openpose',
    value: 97087,
  },
  97088: {
    name: 'sargezt_xl_depth_faid_vidit',
    label: 'sargezt_xl_depth_faid_vidit',
    value: 97088,
  },
  97089: {
    name: 'thibaud_xl_openpose',
    label: 'thibaud_xl_openpose',
    value: 97089,
  },
  97090: {
    name: 'ip-adapter_sd15_plus',
    label: 'ip-adapter_sd15_plus',
    value: 97090,
  },
  97091: {
    name: 't2i-adapter_xl_canny',
    label: 't2i-adapter_xl_canny',
    value: 97091,
  },
  97092: {
    name: 'sai_xl_recolor_256lora',
    label: 'sai_xl_recolor_256lora',
    value: 97092,
  },
  97093: {
    name: 'kohya_controllllite_xl_blur',
    label: 'kohya_controllllite_xl_blur',
    value: 97093,
  },
  97094: {
    name: 'diffusers_xl_depth_full',
    label: 'diffusers_xl_depth_full',
    value: 97094,
  },
  97095: {
    name: 'diffusers_xl_depth_small',
    label: 'diffusers_xl_depth_small',
    value: 97095,
  },
  1128802: {
    name: 'control_sd15_animal_openpose_fp16',
    label: 'control_sd15_animal_openpose_fp16',
    value: 1128802,
  },
  1128803: {
    name: 'ip-adapter-faceid-portrait_sd15',
    label: 'ip-adapter-faceid-portrait_sd15',
    value: 1128803,
  },
  1128804: {
    name: 'ip-adapter-plus-face_sdxl_vit-h',
    label: 'ip-adapter-plus-face_sdxl_vit-h',
    value: 1128804,
  },
  1128806: {
    name: 'control_v1p_sdxl_qrcode_monster',
    label: 'control_v1p_sdxl_qrcode_monster',
    value: 1128806,
  },
  1128807: {
    name: 'control_sd15_inpaint_depth_hand_fp16',
    label: 'control_sd15_inpaint_depth_hand_fp16',
    value: 1128807,
  },
  1128808: {
    name: 'ip-adapter-faceid-plusv2_sd15',
    label: 'ip-adapter-faceid-plusv2_sd15',
    value: 1128808,
  },
  1128809: {
    name: 'control_instant_id_sdxl',
    label: 'control_instant_id_sdxl',
    value: 1128809,
  },
  1128810: {
    name: 'ip-adapter-faceid-portrait-v11_sd15',
    label: 'ip-adapter-faceid-portrait-v11_sd15',
    value: 1128810,
  },
  1128811: {
    name: 'ip-adapter-faceid-plus_sd15',
    label: 'ip-adapter-faceid-plus_sd15',
    value: 1128811,
  },
  1128812: {
    name: 'ip-adapter-faceid_sd15',
    label: 'ip-adapter-faceid_sd15',
    value: 1128812,
  },
  1128813: {
    name: 'ip-adapter_sd15_vit-G',
    label: 'ip-adapter_sd15_vit-G',
    value: 1128813,
  },
  1128814: {
    name: 'ip-adapter_sdxl_vit-h',
    label: 'ip-adapter_sdxl_vit-h',
    value: 1128814,
  },
  1128815: {
    name: 'controlnet-sd-xl-1.0-softedge-dexined',
    label: 'controlnet-sd-xl-1.0-softedge-dexined',
    value: 1128815,
  },
  1128816: {
    name: 'control_any3_openpose',
    label: 'control_any3_openpose',
    value: 1128816,
  },
  1128818: {
    name: 'ip-adapter-faceid_sdxl',
    label: 'ip-adapter-faceid_sdxl',
    value: 1128818,
  },
  1128819: {
    name: 'ip-adapter-plus_sdxl_vit-h',
    label: 'ip-adapter-plus_sdxl_vit-h',
    value: 1128819,
  },
  1128820: {
    name: 'ip-adapter-faceid-plusv2_sdxl',
    label: 'ip-adapter-faceid-plusv2_sdxl',
    value: 1128820,
  },
  1128821: {
    name: 'control_v1p_sd15_brightness',
    label: 'control_v1p_sd15_brightness',
    value: 1128821,
  },
  1128822: {
    name: 'ip-adapter_sd15_light',
    label: 'ip-adapter_sd15_light',
    value: 1128822,
  },
  1128823: {
    name: 'ip-adapter_instant_id_sdxl',
    label: 'ip-adapter_instant_id_sdxl',
    value: 1128823,
  },
  1128824: {
    name: 'controlnet-densepose-sdxl',
    label: 'controlnet-densepose-sdxl',
    value: 1128824,
  },
  1128825: {
    name: 'control_v11p_sd15_densepose_fp16',
    label: 'control_v11p_sd15_densepose_fp16',
    value: 1128825,
  },
  1840281: {
    name: 'xinsir_controlnet-canny-sdxl_V2',
    label: 'xinsir_controlnet-canny-sdxl_V2',
    value: 1840281,
  },
  1840279: {
    name: 'xinsir_controlnet-openpose-sdxl-1.0',
    label: 'xinsir_controlnet-openpose-sdxl-1.0',
    value: 1840279,
  },
  1840280: {
    name: 'xinsir_controlnet-scribble-sdxl-1.0',
    label: 'xinsir_controlnet-scribble-sdxl-1.0',
    value: 1840280,
  },
  1489776: {
    name: 'xinsir_controlnet-canny-sdxl_V2',
    label: 'xinsir_controlnet-canny-sdxl_V2',
    value: 1489776,
  },
  1489774: {
    name: 'xinsir_controlnet-openpose-sdxl-1.0',
    label: 'xinsir_controlnet-openpose-sdxl-1.0',
    value: 1489774,
  },
  2621982: {
    name: 'flux_pose',
    label: 'flux_pose',
    value: 2621982,
  },
  1489775: {
    name: 'xinsir_controlnet-scribble-sdxl-1.0',
    label: 'xinsir_controlnet-scribble-sdxl-1.0',
    value: 1489775,
  },
  // shakker cn models
  1554070: {
    name: 'flux_pose',
    label: 'flux_pose',
    value: 1554070,
  },
  1515779: {
    name: 'XLabs-flux-depth-controlnet_v3',
    label: 'XLabs-flux-depth-controlnet_v3',
    value: 1515779,
  },
  1515786: {
    name: 'XLabs-flux-canny-controlnet_v3',
    label: 'XLabs-flux-canny-controlnet_v3',
    value: 1515786,
  },
  1515789: {
    name: 'XLabs-flux-hed-controlnet_v3',
    label: 'XLabs-flux-hed-controlnet_v3',
    value: 1515789,
  },
  1516174: {
    name: 'InstantX-FLUX.1-dev-Controlnet-Union-alpha',
    label: 'InstantX-FLUX.1-dev-Controlnet-Union-alpha',
    value: 1516174,
  },
  1516175: {
    name: 'InstantX-FLUX.1-dev-Controlnet-canny',
    label: 'InstantX-FLUX.1-dev-Controlnet-canny',
    value: 1516175,
  },
  1516176: {
    name: 'InstantX--V3-Controlnet-canny',
    label: 'InstantX--V3-Controlnet-canny',
    value: 1516176,
  },
  1516178: {
    name: 'InstantX--V3-Controlnet-Pose',
    label: 'InstantX--V3-Controlnet-Pose',
    value: 1516178,
  },
  1516179: {
    name: 'InstantX--V3-Controlnet-Tile',
    label: 'InstantX--V3-Controlnet-Tile',
    value: 1516179,
  },
  1523446: {
    name: 'InstantX-FLUX.1-dev-Controlnet-Union-Pro',
    label: 'InstantX-FLUX.1-dev-Controlnet-Union-Pro',
    value: 1523446,
  },
  1523488: {
    name: 'Q8_0',
    label: 'Q8_0',
    value: 1523488,
  },
  1523489: {
    name: 'nf4',
    label: 'nf4',
    value: 1523489,
  },
  1526152: {
    name: 'XLabs-Flux-ip-adapter',
    label: 'XLabs-Flux-ip-adapter',
    value: 1526152,
  },
  18402721: {
    name: 'InstantX-F.1-dev-IP-Adapter',
    label: 'InstantX-F.1-dev-IP-Adapter',
    value: 18402721,
  },
  // pic cn models
  2417791: {
    name: 'XLabs-flux-depth-controlnet_v3',
    label: 'XLabs-flux-depth-controlnet_v3',
    value: 2417791,
  },
  2417887: {
    name: 'XLabs-flux-canny-controlnet_v3',
    label: 'XLabs-flux-canny-controlnet_v3',
    value: 2417887,
  },
  2417932: {
    name: 'XLabs-flux-hed-controlnet_v3',
    label: 'XLabs-flux-hed-controlnet_v3',
    value: 2417932,
  },
  2426423: {
    name: 'InstantX-FLUX.1-dev-Controlnet-Union-alpha',
    label: 'InstantX-FLUX.1-dev-Controlnet-Union-alpha',
    value: 2426423,
  },
  2426439: {
    name: 'InstantX-FLUX.1-dev-Controlnet-Canny',
    label: 'InstantX-FLUX.1-dev-Controlnet-Canny',
    value: 2426439,
  },
  2426451: {
    name: 'InstantX--V3-Controlnet-Canny',
    label: 'InstantX--V3-Controlnet-Canny',
    value: 2426451,
  },
  2426481: {
    name: 'InstantX--V3-Controlnet-Pose',
    label: 'InstantX--V3-Controlnet-Pose',
    value: 2426481,
  },
  2426489: {
    name: 'InstantX--V3-Controlnet-Tile',
    label: 'InstantX--V3-Controlnet-Tile',
    value: 2426489,
  },
  2495516: {
    name: 'InstantX-FLUX.1-dev-Controlnet-Union-Pro',
    label: 'InstantX-FLUX.1-dev-Controlnet-Union-Pro',
    value: 2495516,
  },
  2495921: {
    name: 'Q8_0',
    label: 'Q8_0',
    value: 2495921,
  },
  2495943: {
    name: 'nf4',
    label: 'nf4',
    value: 2495943,
  },
  2508000: {
    name: 'XLabs-Flux-ip-adapter',
    label: 'XLabs-Flux-ip-adapter',
    value: 2508000,
  },
};

const processorsOptionsMap = {
  1: {
    label: 'canny',
    name: 'CANNY',
    value: 1,
  },
  2: {
    label: 'depth',
    name: 'DEPTH',
    value: 2,
  },
  3: {
    label: 'depth_leres',
    name: 'DEPTH_LERES',
    value: 3,
  },
  4: {
    label: 'depth_leres++',
    name: 'DEPTH_LERES_PLUS',
    value: 4,
  },
  5: {
    label: 'hed',
    name: 'HED',
    value: 5,
  },
  6: {
    label: 'hed_safe',
    name: 'HED_SAFE',
    value: 6,
  },
  7: {
    label: 'mediapipe_face',
    name: 'MEDIAPIPE_FACE',
    value: 7,
  },
  8: {
    label: 'mlsd',
    name: 'MLSD',
    value: 8,
  },
  9: {
    label: 'normal_map',
    name: 'NORMAL_MAP',
    value: 9,
  },
  10: {
    label: 'openpose',
    name: 'OPENPOSE',
    value: 10,
  },
  11: {
    label: 'openpose hand',
    name: 'OPENPOSE_HAND',
    value: 11,
  },
  12: {
    label: 'openpose face',
    name: 'OPENPOSE_FACE',
    value: 12,
  },
  13: {
    label: 'openpose_faceonly',
    name: 'OPENPOSE_FACEONLY',
    value: 13,
  },
  14: {
    label: 'openpose_full',
    name: 'OPENPOSE_FULL',
    value: 14,
  },
  15: {
    label: 'clip_vision',
    name: 'CLIP_VISION',
    value: 15,
  },
  16: {
    label: 'color',
    name: 'COLOR',
    value: 16,
  },
  17: {
    label: 'pidinet',
    name: 'PIDINET',
    value: 17,
  },
  18: {
    label: 'pidinet_safe',
    name: 'PIDINET_SAFE',
    value: 18,
  },
  19: {
    label: 'pidinet_sketch',
    name: 'PIDINET_SKETCH',
    value: 19,
  },
  20: {
    label: 'scribble_pidinet',
    name: 'PIDINET_SCRIBBLE',
    value: 20,
  },
  21: {
    label: 'scribble_xdog',
    name: 'SCRIBBLE_XDOG',
    value: 21,
  },
  22: {
    label: 'scribble_hed',
    name: 'SCRIBBLE_HED',
    value: 22,
  },
  23: {
    label: 'segmentation',
    name: 'SEGMENTATION',
    value: 23,
  },
  24: {
    label: 'threshold',
    name: 'THRESHOLD',
    value: 24,
  },
  25: {
    label: 'depth_zoe',
    name: 'DEPTH_ZOE',
    value: 25,
  },
  26: {
    label: 'normal bae',
    name: 'NORMAL_BAE',
    value: 26,
  },
  27: {
    label: 'oneformer_coco',
    name: 'ONEFORMER_COCO',
    value: 27,
  },
  28: {
    label: 'oneformer_ade20k',
    name: 'ONEFORMER_ADE20K',
    value: 28,
  },
  29: {
    label: 'lineart',
    name: 'LINEART',
    value: 29,
  },
  30: {
    label: 'lineart coarse',
    name: 'LINEART_COARSE',
    value: 30,
  },
  31: {
    label: 'lineart_anime',
    name: 'LINEART_ANIME',
    value: 31,
  },
  32: {
    label: 'lineart standard',
    name: 'LINEART_STANDARD',
    value: 32,
  },
  33: {
    label: 'shuffle',
    name: 'SHUFFLE',
    value: 33,
  },
  34: {
    label: 'tile_resample',
    name: 'TILE_RESAMPLE',
    value: 34,
  },
  35: {
    label: 'invert',
    name: 'INVERT',
    value: 35,
  },
  36: {
    label: 'lineart_anime_denoise',
    name: 'LINEART_ANIME_DENOISE',
    value: 36,
  },
  37: {
    label: 'reference_only',
    name: 'REFERENCE_ONLY',
    value: 37,
  },
  38: {
    label: 'reference_adain',
    name: 'REFERENCE_ADAIN',
    value: 38,
  },
  39: {
    label: 'reference_adain+attn',
    name: 'REFERENCE_ADAIN_ATTN',
    value: 39,
  },
  40: {
    label: 'inpaint',
    name: 'INPAINT',
    value: 40,
  },
  41: {
    label: 'inpaint_only',
    name: 'INPAINT_ONLY',
    value: 41,
  },
  42: {
    label: 'inpaint_only+lama',
    name: 'INPAINT_ONLY_LAMA',
    value: 42,
  },
  43: {
    label: 'tile_colorfix',
    name: 'TILE_COLORFIX',
    value: 43,
  },
  44: {
    label: 'tile_colorfix+sharp',
    name: 'TILE_COLORFIX_SHARP',
    value: 44,
  },
  45: {
    label: 'dw_openpose_full',
    name: 'DW_OPENPOSE_FULL',
    value: 45,
  },
  46: {
    label: 'revision_clipvision',
    name: 'REVISION_CLIPVISION',
    value: 46,
  },
  47: {
    label: 'revision_ignore_prompt',
    name: 'REVISION_IGNORE_PROMPT',
    value: 47,
  },
  48: {
    label: 'ip-adapter_clip_sd15',
    name: 'IP_ADAPTER_CLIP_SD15',
    value: 48,
  },
  49: {
    label: 'ip-adapter_clip_sdxl',
    name: 'IP_ADAPTER_CLIP_SDXL',
    value: 49,
  },
  50: {
    label: 'recolor_luminance',
    name: 'RECOLOR_LUMINANCE',
    value: 50,
  },
  51: {
    label: 'recolor_intensity',
    name: 'RECOLOR_INTENSITY',
    value: 51,
  },
  52: {
    label: 'Blur Gaussian',
    name: 'BLUR_GAUSSIAN',
    value: 52,
  },
  53: {
    label: 'animal_openpose',
    name: 'ANIMAL_OPENPOSE',
    value: 53,
  },
  54: {
    label: 'anime_face_segment',
    name: 'ANIME_FACE_SEGMENT',
    value: 54,
  },
  55: {
    label: 'densepose',
    name: 'DENSEPOSE',
    value: 55,
  },
  56: {
    label: 'densepose_parula',
    name: 'DENSEPOSE_PARULA',
    value: 56,
  },
  57: {
    label: 'depth_hand_refiner',
    name: 'DEPTH_HAND_REFINER',
    value: 57,
  },
  58: {
    label: 'softedge_teed',
    name: 'SOFTEDGE_TEED',
    value: 58,
  },
  59: {
    label: 'instant_id_face_keypoints',
    name: 'INSTANT_ID_FACE_KEYPOINTS',
    value: 59,
  },
  60: {
    label: 'instant_id_face_embedding',
    name: 'INSTANT_ID_FACE_EMBEDDING',
    value: 60,
  },
  61: {
    label: 'ip-adapter_clip_sdxl_plus_vith',
    name: 'IP_ADAPTER_CLIP_SDXL_PLUS_VITH',
    value: 61,
  },
  62: {
    label: 'ip-adapter_face_id',
    name: 'IP_ADAPTER_FACE_ID',
    value: 62,
  },
  63: {
    label: 'ip-adapter_face_id_plus',
    name: 'IP_ADAPTER_FACE_ID_PLUS',
    value: 63,
  },
  64: {
    label: 'depth_anything',
    name: 'DEPTH_ANYTHING',
    value: 64,
  },
  65: {
    label: 'softedge_anyline',
    name: 'SOFTEDGE_ANYLINE',
    value: 65,
  },
  68: {
    label: 'entity_control',
    name: 'ENTITY_CONTROL',
    value: 68,
  },
};

export const processorsMap = {
  CANNY: '1',
  DEPTH: '2',
  DEPTH_LERES: '3',
  DEPTH_LERES_PLUS: '4',
  HED: '5',
  HED_SAFE: '6',
  MEDIAPIPE_FACE: '7',
  MLSD: '8',
  NORMAL_MAP: '9',
  OPENPOSE: '10',
  OPENPOSE_HAND: '11',
  OPENPOSE_FACE: '12',
  OPENPOSE_FACEONLY: '13',
  OPENPOSE_FULL: '14',
  CLIP_VISION: '15',
  COLOR: '16',
  PIDINET: '17',
  PIDINET_SAFE: '18',
  PIDINET_SKETCH: '19',
  PIDINET_SCRIBBLE: '20',
  SCRIBBLE_XDOG: '21',
  SCRIBBLE_HED: '22',
  SEGMENTATION: '23',
  THRESHOLD: '24',
  DEPTH_ZOE: '25',
  NORMAL_BAE: '26',
  ONEFORMER_COCO: '27',
  ONEFORMER_ADE20K: '28',
  LINEART: '29',
  LINEART_COARSE: '30',
  LINEART_ANIME: '31',
  LINEART_STANDARD: '32',
  SHUFFLE: '33',
  TILE_RESAMPLE: '34',
  INVERT: '35',
  LINEART_ANIME_DENOISE: '36',
  REFERENCE_ONLY: '37',
  REFERENCE_ADAIN: '38',
  REFERENCE_ADAIN_ATTN: '39',
  INPAINT: '40',
  INPAINT_ONLY: '41',
  INPAINT_ONLY_LAMA: '42',
  TILE_COLORFIX: '43',
  TILE_COLORFIX_SHARP: '44',
  DW_OPENPOSE_FULL: '45',
  REVISION_CLIPVISION: '46',
  REVISION_IGNORE_PROMPT: '47',
  IP_ADAPTER_CLIP_SD15: '48',
  IP_ADAPTER_CLIP_SDXL: '49',
  RECOLOR_LUMINANCE: '50',
  RECOLOR_INTENSITY: '51',
  BLUR_GAUSSIAN: '52',
  ANIMAL_OPENPOSE: '53',
  ANIME_FACE_SEGMENT: '54',
  DENSEPOSE: '55',
  DENSEPOSE_PARULA: '56',
  DEPTH_HAND_REFINER: '57',
  SOFTEDGE_TEED: '58',
  INSTANT_ID_FACE_KEYPOINTS: '59',
  INSTANT_ID_FACE_EMBEDDING: '60',
  IP_ADAPTER_CLIP_SDXL_PLUS_VITH: '61',
  IP_ADAPTER_FACE_ID: '62',
  IP_ADAPTER_FACE_ID_PLUS: '63',
  DEPTH_ANYTHING: '64',
  SOFTEDGE_ANYLINE: '65',
  ENTITY_CONTROL: '68',
};

export const controlNetConfig = {
  reference: {
    [MODEL_SD15]: {
      preprocessors: [],
      models: [],
    },
    [MODEL_SDXL]: {
      preprocessors: [],
      models: [],
    },
    [MODEL_PONY]: {
      preprocessors: [],
      models: [],
    },
  },
  face: {
    [MODEL_SDXL]: {
      preprocessors: [],
      models: [],
    },
  },
  brightness: {
    [MODEL_SD15]: {
      preprocessors: [35],
      models: [1128821],
    },
  },
  canny: {
    [MODEL_SD15]: {
      preprocessors: [1, 35],
      models: [22547, 23338, 23340],
    },
    [MODEL_SDXL]: {
      preprocessors: [1, 35],
      models: [isOverseas ? 1489776 : 1840281, 97068, 97070, 97061, 97091, 97072, 97077, 97083, 97055, 97060],
    },
    [MODEL_FLUX]: {
      preprocessors: [1, 35],
      models: isOverseas ? [1523446, 1515786] : [2495516, 2417887],
    },
    [MODEL_PONY]: {
      preprocessors: [1, 35],
      models: [isOverseas ? 1489776 : 1840281, 97068, 97070, 97061, 97091, 97072, 97077, 97083, 97055, 97060],
    },
  },
  depth: {
    [MODEL_SD15]: {
      preprocessors: [2, 3, 4, 25, 57],
      models: [23336, 23339, 23342, 23349, 1128807],
    },
    [MODEL_SDXL]: {
      preprocessors: [2, 3, 4, 25, 64],
      models: [97095, 97094, 97064, 97081, 97086, 97079, 97088, 97078, 97062, 97053, 97056, 97076],
    },
    [MODEL_FLUX]: {
      preprocessors: [2, 3, 4, 25, 64],
      models: [isOverseas ? 1523446 : 2495516],
    },
    [MODEL_PONY]: {
      preprocessors: [2, 3, 4, 25],
      models: [97095, 97094, 97064, 97081, 97086, 97079, 97088, 97078, 97062, 97053, 97056, 97076],
    },
  },
  normal: {
    [MODEL_SD15]: {
      preprocessors: [26, 9],
      models: [22544],
    },
  },
  openpose: {
    [MODEL_SD15]: {
      preprocessors: [45, 10, 11, 12, 13, 14, 53, 55, 56],
      models: [22546, 23344, 1128802, 1128825],
    },
    [MODEL_SDXL]: {
      preprocessors: [45, 10, 11, 12, 13, 14, 55, 56],
      models: [isOverseas ? 1489774 : 1840279, 97063, 97058, 97089, 97074, 97087, 97069, 1128824],
    },
    [MODEL_FLUX]: {
      preprocessors: [45, 10, 11, 12, 13, 14, 55, 56],
      models: [isOverseas ? 1554070 : 2621982],
    },
    [MODEL_PONY]: {
      preprocessors: [45, 10, 11, 12, 13, 14, 55, 56],
      models: [isOverseas ? 1489774 : 1840279, 97063, 97058, 97089, 97074, 97087, 97069, 1128824],
    },
  },
  mlsd: {
    [MODEL_SD15]: {
      preprocessors: [8, 35],
      models: [22554],
    },
  },
  lineart: {
    [MODEL_SD15]: {
      preprocessors: [29, 30, 31, 32, 36, 35],
      models: [22555, 22545],
    },
    [MODEL_SDXL]: {
      preprocessors: [29, 30, 31, 32, 36, 35],
      models: [97065],
    },
    [MODEL_PONY]: {
      preprocessors: [29, 30, 31, 32, 36, 35],
      models: [97065],
    },
  },
  soft_edge: {
    [MODEL_SD15]: {
      preprocessors: [
        Number(processorsMap.PIDINET_SCRIBBLE),
        Number(processorsMap.SCRIBBLE_XDOG),
        Number(processorsMap.SCRIBBLE_HED),
        Number(processorsMap.INVERT),
      ],
      models: [22550],
    },
    [MODEL_SDXL]: {
      preprocessors: [
        Number(processorsMap.PIDINET_SCRIBBLE),
        Number(processorsMap.SCRIBBLE_XDOG),
        Number(processorsMap.SCRIBBLE_HED),
        Number(processorsMap.INVERT),
      ],
      models: [97067, 1128815],
    },
    [MODEL_FLUX]: {
      preprocessors: [
        Number(processorsMap.SOFTEDGE_ANYLINE),
        Number(processorsMap.PIDINET_SCRIBBLE),
        Number(processorsMap.SCRIBBLE_XDOG),
        Number(processorsMap.SCRIBBLE_HED),
        Number(processorsMap.INVERT),
      ],
      models: [isOverseas ? 1523446 : 2495516],
    },
    [MODEL_PONY]: {
      preprocessors: [
        Number(processorsMap.PIDINET_SCRIBBLE),
        Number(processorsMap.SCRIBBLE_XDOG),
        Number(processorsMap.SCRIBBLE_HED),
        Number(processorsMap.INVERT),
      ],
      models: [97067, 1128815],
    },
  },
  scribble: {
    [MODEL_SD15]: {
      preprocessors: [20, 21, 22, 35],
      models: [22551],
    },
    [MODEL_SDXL]: {
      preprocessors: [20, 21, 22, 35],
      models: [isOverseas ? 1489775 : 1840280, 97066, 97052, 97084, 97073, 97059],
    },
    [MODEL_PONY]: {
      preprocessors: [20, 21, 22, 35],
      models: [isOverseas ? 1489775 : 1840280, 97066, 97052, 97084, 97073, 97059],
    },
  },
  segment: {
    [MODEL_SD15]: {
      preprocessors: [23, 28, 27, 54],
      models: [22548, 23345],
    },
  },
  shuffle: {
    [MODEL_SD15]: {
      preprocessors: [33],
      models: [22553],
    },
  },
  tile: {
    [MODEL_SD15]: {
      preprocessors: [34, 43, 44, 52],
      models: [22552],
    },
    [MODEL_FLUX]: {
      preprocessors: [34, 43, 44, 52],
      models: [isOverseas ? 1523446 : 2495516], // ??? InstantX-FLUX.1-dev-Controlnet-Union-Pro
    },
    [MODEL_SDXL]: {
      preprocessors: [52],
      models: [97093, 97080, 97054],
    },
    [MODEL_PONY]: {
      preprocessors: [52],
      models: [97093, 97080, 97054],
    },
  },
  inpaint: {
    [MODEL_SD15]: {
      preprocessors: [40, 41, 42],
      models: [23337],
    },
  },
  // ip2p: {
  //   [MODEL_SD15]: {
  //     preprocessors: [],
  //     models: [22549],
  //   },
  // },
  reference_only: {
    [MODEL_SD15]: {
      preprocessors: [37, 38, 39],
      models: [],
    },
  },
  t2ia: {
    [MODEL_SD15]: {
      preprocessors: [16, 19, 15],
      models: [23341, 23338, 23339, 23340, 23342, 23343, 23344, 23345, 23346, 23347, 23348, 23349],
    },
  },
  recolor: {
    [MODEL_SD15]: {
      preprocessors: [50, 51],
      models: [97082],
    },
    [MODEL_SDXL]: {
      preprocessors: [50, 51],
      models: [97075, 97092],
    },
    [MODEL_PONY]: {
      preprocessors: [50, 51],
      models: [97075, 97092],
    },
  },
  revision: {
    [MODEL_SD15]: {
      preprocessors: [46, 47],
      models: [],
    },
    [MODEL_SDXL]: {
      preprocessors: [46, 47],
      models: [],
    },
    [MODEL_PONY]: {
      preprocessors: [46, 47],
      models: [],
    },
  },
  ip_adapter: {
    [MODEL_SD15]: {
      preprocessors: [48, 62, 63],
      models: [97057, 97090, 1128822, 1128813, 1128810, 1128803, 1128812, 1128811, 1128808],
    },
    [MODEL_SDXL]: {
      preprocessors: [49, 61, 62, 63],
      models: [97071, 1128814, 1128819, 1128818, 1128804, 1128820],
    },
    [MODEL_FLUX]: {
      preprocessors: [processorsMap.IP_ADAPTER_CLIP_SD15],
      models: isOverseas ? [18402721, 1526152] : [18402721, 2508000],
    },
    [MODEL_PONY]: {
      preprocessors: [49, 61, 62, 63],
      models: [97071, 1128814, 1128819, 1128818, 1128804, 1128820],
    },
  },
  instant_id: {
    [MODEL_SD15]: {
      preprocessors: [],
      models: [],
    },
    [MODEL_SDXL]: {
      preprocessors: [60, 59],
      models: [1128823, 1128809],
    },
    [MODEL_PONY]: {
      preprocessors: [60, 59],
      models: [1128823, 1128809],
    },
  },
  entity_control: {
    [MODEL_FLUX]: {
      preprocessors: [Number(processorsMap.ENTITY_CONTROL)],
      models: isOverseas ? [18779560] : [18853825],
    },
  },
};

export const controlOptionsShouldTriggerPreprocess = [
  'preprocessor',
  'preprocessorResolution',
  'downSamplingRate',
  'variation',
  'sharpness',
  'sigma',
  'lowThreshold',
  'highThreshold',
  'valueThreshold',
  'distanceThreshold',
  'XDOGThreshold',
  'safeSteps',
  'removeNear',
  'removeBackground',
  'backgroundThreshold',
  'gammaCorrection',
];

export const controlNetInitialValues = {
  resizeMode: 1,
  controlMode: 0,
  preprocessorResolution: 512,
  pixelPerfect: 1,
  downSamplingRate: 1,
  sharpness: 1,
  variation: 8,
  sigma: 9,
  lowThreshold: 100,
  highThreshold: 100,
  valueThreshold: 0.1,
  distanceThreshold: 0.1,
  safeSteps: 2,
  removeNear: 0,
  removeBackground: 0,
  backgroundThreshold: 0.4,
  XDOGThreshold: 32,
  styleFidelity: 0.5,
  gammaCorrection: 1,
  startingControlStep: 0,
  endingControlStep: 1,
  referenceType: 'preset',
  faceType: 'front',
  bodyType: 'halfbody',
};

export const processorSubParams = {
  // Tile
  [processorsMap.BLUR_GAUSSIAN]: { name: 'blurGaussian', items: ['sigma'] },
  [processorsMap.TILE_RESAMPLE]: { name: 'tileResample', items: ['downSamplingRate', 'sharpness'] },
  [processorsMap.TILE_COLORFIX]: { name: 'tileColorfix', items: ['variation'] },
  [processorsMap.TILE_COLORFIX_SHARP]: { name: 'tileColorfixSharp', items: ['variation', 'sharpness'] },

  // Reference Only
  [processorsMap.REFERENCE_ONLY]: { name: 'referenceOnly', items: ['styleFidelity'] },
  [processorsMap.REFERENCE_ADAIN]: { name: 'referenceAdain', items: ['styleFidelity'] },
  [processorsMap.REFERENCE_ADAIN_ATTN]: { name: 'referenceAdainAttn', items: ['styleFidelity'] },

  // Canny & MLSD
  [processorsMap.CANNY]: { name: 'canny', items: ['preprocessorResolution', 'lowThreshold', 'highThreshold'] },
  [processorsMap.INVERT]: { name: 'invert', items: ['preprocessorResolution'] },
  [processorsMap.MLSD]: { name: 'mlsd', items: ['preprocessorResolution', 'valueThreshold', 'distanceThreshold'] },

  // Lineart
  [processorsMap.LINEART]: { name: 'lineart', items: ['preprocessorResolution'] },
  [processorsMap.LINEART_ANIME]: { name: 'lineartAnime', items: ['preprocessorResolution'] },
  [processorsMap.LINEART_STANDARD]: { name: 'lineartStandard', items: ['preprocessorResolution'] },
  [processorsMap.LINEART_ANIME_DENOISE]: { name: 'lineartAnimeDenoise', items: ['preprocessorResolution'] },
  [processorsMap.LINEART_COARSE]: { name: 'lineartCoarse', items: ['preprocessorResolution'] },

  // Soft Edge
  [processorsMap.PIDINET_SCRIBBLE]: { name: 'pidinetScribble', items: ['preprocessorResolution'] },
  [processorsMap.SCRIBBLE_XDOG]: { name: 'scribbleXdog', items: ['preprocessorResolution', 'xDoGThreshold'] },
  [processorsMap.SOFTEDGE_TEED]: { name: 'softedgeTeed', items: ['preprocessorResolution', 'safeSteps'] },

  // Scribble
  [processorsMap.PIDINET]: { name: 'pidinet', items: ['preprocessorResolution'] },
  [processorsMap.HED]: { name: 'hed', items: ['preprocessorResolution'] },
  [processorsMap.HED_SAFE]: { name: 'hedSafe', items: ['preprocessorResolution'] },
  [processorsMap.PIDINET_SAFE]: { name: 'scribble', items: ['preprocessorResolution'] },

  // Depth
  [processorsMap.DEPTH_LERES]: {
    name: 'depthLeres',
    items: ['preprocessorResolution', 'removeNear', 'removeBackground'],
  },
  [processorsMap.DEPTH_LERES_PLUS]: {
    name: 'depthLeresPlus',
    items: ['preprocessorResolution', 'removeNear', 'removeBackground'],
  },
  [processorsMap.DEPTH]: { name: 'depth', items: ['preprocessorResolution'] },
  [processorsMap.DEPTH_ZOE]: { name: 'depthZoe', items: ['preprocessorResolution'] },
  [processorsMap.DEPTH_ANYTHING]: { name: 'depthAnything', items: ['preprocessorResolution'] },
  [processorsMap.DEPTH_HAND_REFINER]: { name: 'depthHandRefiner', items: ['preprocessorResolution'] },

  // Segmentation
  [processorsMap.ONEFORMER_ADE20K]: { name: 'oneformerAde20k', items: ['preprocessorResolution'] },
  [processorsMap.ONEFORMER_COCO]: { name: 'oneformerCoco', items: ['preprocessorResolution'] },
  [processorsMap.SEGMENTATION]: { name: 'segmentation', items: ['preprocessorResolution'] },
  [processorsMap.ANIME_FACE_SEGMENT]: { name: 'animeFaceSegment', items: ['preprocessorResolution'] },

  // Normal
  [processorsMap.NORMAL_MAP]: { name: 'normalMap', items: ['preprocessorResolution', 'backgroundThreshold'] },
  [processorsMap.NORMAL_BAE]: { name: 'normalBae', items: ['preprocessorResolution'] },

  // IP Adapter
  [processorsMap.IP_ADAPTER_CLIP_SD15]: { name: 'ipAdapterClipSd15', items: ['preprocessorResolution'] },
  [processorsMap.IP_ADAPTER_CLIP_SDXL]: { name: 'ipAdapterClipSdxl', items: ['preprocessorResolution'] },
  [processorsMap.IP_ADAPTER_CLIP_SDXL_PLUS_VITH]: {
    name: 'ipAdapterClipSdxlPlusVith',
    items: ['preprocessorResolution'],
  },
  [processorsMap.IP_ADAPTER_FACE_ID]: { name: 'ipAdapterFaceId', items: ['preprocessorResolution'] },
  [processorsMap.IP_ADAPTER_FACE_ID_PLUS]: { name: 'ipAdapterFaceIdPlus', items: ['preprocessorResolution'] },

  // Openpose
  [processorsMap.OPENPOSE]: { name: 'openpose', items: ['preprocessorResolution'] },
  [processorsMap.DW_OPENPOSE_FULL]: { name: 'dwOpenposeFull', items: ['preprocessorResolution'] },
  [processorsMap.OPENPOSE_FACE]: { name: 'openposeFace', items: ['preprocessorResolution'] },
  [processorsMap.OPENPOSE_FULL]: { name: 'openposeFull', items: ['preprocessorResolution'] },
  [processorsMap.OPENPOSE_FACEONLY]: { name: 'openposeFaceonly', items: ['preprocessorResolution'] },
  [processorsMap.OPENPOSE_HAND]: { name: 'openposeHand', items: ['preprocessorResolution'] },
  [processorsMap.ANIMAL_OPENPOSE]: { name: 'animalOpenpose', items: ['preprocessorResolution'] },
  [processorsMap.DENSEPOSE]: { name: 'densepose', items: ['preprocessorResolution'] },
  [processorsMap.DENSEPOSE_PARULA]: { name: 'denseposeParula', items: ['preprocessorResolution'] },

  // T2IA
  [processorsMap.COLOR]: { name: 'color', items: ['preprocessorResolution'] },
  [processorsMap.PIDINET_SKETCH]: { name: 'pidinetSketch', items: ['preprocessorResolution'] },
  [processorsMap.CLIP_VISION]: { name: 'clipVision', items: ['preprocessorResolution'] },

  // Shuffle
  [processorsMap.SHUFFLE]: { name: 'shuffle', items: ['preprocessorResolution'] },

  // Recolor
  [processorsMap.RECOLOR_INTENSITY]: {
    name: 'recolorIntensity',
    items: ['preprocessorResolution', 'gammaCorrection'],
  },
  [processorsMap.RECOLOR_LUMINANCE]: {
    name: 'recolorLuminance',
    items: ['preprocessorResolution', 'gammaCorrection'],
  },
  [processorsMap.INSTANT_ID_FACE_EMBEDDING]: {
    name: 'instantIdFaceEmbedding',
    items: ['preprocessorResolution'],
  },
  [processorsMap.INSTANT_ID_FACE_KEYPOINTS]: {
    name: 'instantIdFaceKeypoints',
    items: ['preprocessorResolution'],
  },

  // Entity Control
  [processorsMap.ENTITY_CONTROL]: {
    name: 'entityControl',
    items: ['preprocessorResolution'],
  },
};

export const getPreprocessors = (id, baseType, defaultValue) => {
  const options = controlNetConfig[id][baseType]?.preprocessors || [];
  defaultValue = defaultValue || options[0];

  return {
    type: 'select',
    name: 'preprocessor',
    label: translate('cn_preprocessor'),
    defaultValue: defaultValue,
    options: options.map((value) => ({
      label: translate(processorsOptionsMap[value]?.label || value),
      value: processorsOptionsMap[value]?.value + '',
    })),
  };
};

export const getModels = (id, baseType, defaultValue) => {
  const options = controlNetConfig[id][baseType]?.models || [];
  defaultValue = defaultValue || options[0];

  return {
    type: 'select',
    name: 'model',
    label: translate('cn_model'),
    defaultValue: defaultValue,
    options: options.map((value) => ({
      label: translate(modelsMap[value].label),
      value: modelsMap[value].value + '',
    })),
  };
};

export const facialReferenceImages = {
  fullbody_front: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/ef0dcb7efd5c605165c90be73ea6c667daa952f0a360192b131404d4b47cc8ef.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/ef0dcb7efd5c605165c90be73ea6c667daa952f0a360192b131404d4b47cc8ef.png',
    width: 1024,
    height: 1536,
  },
  fullbody_right: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/08463a5c09155df2f6ce544b1ad4c6b17428d96796d75a8e892fe178af90a93b.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/08463a5c09155df2f6ce544b1ad4c6b17428d96796d75a8e892fe178af90a93b.png',
    width: 768,
    height: 1336,
  },
  fullbody_left: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/6f97cb69b9b9b0381105d64ad3b3543237d973c74fee54975370496d54be3015.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/6f97cb69b9b9b0381105d64ad3b3543237d973c74fee54975370496d54be3015.png',
    width: 728,
    height: 1328,
  },
  halfbody_front: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/44d9bb7b7fefe5eb6cda3fcfeaeaad2443abd732fd69ffa87477f0cf45cad877.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/44d9bb7b7fefe5eb6cda3fcfeaeaad2443abd732fd69ffa87477f0cf45cad877.png',
    width: 768,
    height: 1024,
  },
  halfbody_right: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/89508b459963b0e3c3731abddf99066ea4db09a2e4ca0d59e2ecd2d7cc297fbb.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/89508b459963b0e3c3731abddf99066ea4db09a2e4ca0d59e2ecd2d7cc297fbb.png',
    width: 640,
    height: 960,
  },
  halfbody_left: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/affc51f1b6d0b0b0ce5c4c4f62a1028044abdaa381b75178db953e2927bdc42c.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/affc51f1b6d0b0b0ce5c4c4f62a1028044abdaa381b75178db953e2927bdc42c.png',
    width: 768,
    height: 1024,
  },
  portrait_front: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/e69d5d5ddeb52f0061636d6109998670404d8548d5ba7fe6d8fe40d6eb0f7241.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/e69d5d5ddeb52f0061636d6109998670404d8548d5ba7fe6d8fe40d6eb0f7241.png',
    width: 768,
    height: 1152,
  },
  portrait_right: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/d6b9c8aa889e8472a8403442321f40a446d5b35f103f407986a163a128c183bb.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/d6b9c8aa889e8472a8403442321f40a446d5b35f103f407986a163a128c183bb.png',
    width: 1024,
    height: 1536,
  },
  portrait_left: {
    picUrl:
      'https://liblibai-online.oss-cn-beijing.aliyuncs.com/sd-images/86447502c8af6b4522f8f015f58eb7fe21f582c37f486cd900c776e78321e039.png',
    shkUrl:
      'https://models-online-persist-us.oss-us-east-1.aliyuncs.com/sd-images/86447502c8af6b4522f8f015f58eb7fe21f582c37f486cd900c776e78321e039.png',
    width: 768,
    height: 1152,
  },
};

export const facialReferenceImages_ = isOverseas
  ? {
      1: 'https://models-online-persist.shakker.ai/sd-images/cb357e8ccb9cdd6c4b30c79213ba2b83165f219a3f3137bfadf91467fb4589b6.png',
      2: 'https://models-online-persist.shakker.ai/sd-images/ad19f17d47b978055324c0c619ad507196d0991f3988076c3a01736397ab3cb3.png',
      3: 'https://models-online-persist.shakker.ai/sd-images/f15c3d09a89ae8e781b89c2ba63222dc9f4eafc5ff0001880a62419ee9f04874.png',
      4: 'https://models-online-persist.shakker.ai/sd-images/e9b6306a6ad9c4c47fbe6e1b0b0653414aa8a55b5f5b3c53416dc09c4c48b674.png',
    }
  : {
      1: 'https://liblibai-online.liblib.cloud/sd-images/8a6afc7f0a938ff40bedddf769438f04a08a2e9067787d26b2f30aa8c9acf9f2.png',
      2: 'https://liblibai-online.liblib.cloud/sd-images/c292eb0b53826bdfa36e422da26a656b598f5e22167585f89db545fce86d433d.png',
      3: 'https://liblibai-online.liblib.cloud/sd-images/86c3f6d80bda5c8456ceed568cf9fb206ed982fc9c3b800366e65ef78d346e4f.png',
      4: 'https://liblibai-online.liblib.cloud/sd-images/4e1f6fa8bfd1b5366a1bdc9cf414654dfb0f960b83ebb488f3114d90b8575e64.png',
    };

export const facialPresetImageSize = { width: 768, height: 1152 };

export const facialReferenceDefaultValues = {
  'faceEmbeding.controlWeight': 0.6,
  'faceEmbeding.startingControlStep': 0,
  'faceEmbeding.endingControlStep': 0.9,
  'faceEmbeding.resizeMode': '1',
  'faceKeypoints.controlWeight': 0.6,
  'faceKeypoints.startingControlStep': 0,
  'faceKeypoints.endingControlStep': 1,
  'faceKeypoints.resizeMode': '2',
};

export const controlRangeOption = [
  {
    type: 'number',
    min: 0,
    max: 1,
    step: 0.1,
    defaultValue: 0,
    name: 'startingControlStep',
    label: translate('cn_control_start_step'),
  },
  {
    type: 'number',
    min: 0,
    max: 1,
    step: 0.1,
    defaultValue: 1,
    name: 'endingControlStep',
    label: translate('cn_control_end_step'),
  },
];

export const controlWeightOption = {
  type: 'number',
  min: 0,
  max: 1,
  step: 0.1,
  name: 'controlWeight',
  defaultValue: 0.8,
  label: translate('cn_control_weight'),
};

export const pixelPerfectOption = {
  type: 'select',
  name: 'pixelPerfect',
  label: translate('cn_pixel_perfect'),
  defaultValue: '1',
  options: [
    {
      value: '1',
      label: translate('cn_pixel_perfect_on'),
    },
    {
      value: '0',
      label: translate('cn_pixel_perfect_off'),
    },
  ],
};

export const getPreprocessorResolutionOption = (options) => {
  return {
    type: 'number',
    min: 64,
    max: 1024,
    step: 8,
    defaultValue: 512,
    name: 'preprocessorResolution',
    label: translate('cn_preprocessor_resolution'),
    ...options,
  };
};

export const simpleModeSupportedControlNets = {
  face: true,
  depth: true,
  canny: true,
  openpose: true,
  ip_adapter: true,
  entity_control: true,
  // t2ia: true,
};

export const controlNetList = [
  {
    value: 'depth',
    label: translate('imgref_mode_depth'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
    inpaintSupported: true,
  },
  {
    value: 'canny',
    label: translate('imgref_mode_canny'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
    inpaintSupported: true,
  },
  {
    value: 'face',
    label: translate('cn_face'),
    baseTypes: [MODEL_SDXL, MODEL_ILLUS, MODEL_PONY],
    inpaintSupported: true,
  },
  {
    value: 'openpose',
    label: translate('imgref_mode_openpose'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
  },
  {
    value: 'ip_adapter',
    label: translate('imgref_mode_ip_adapter'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
  },
  {
    value: 'entity_control',
    label: translate('imgref_mode_entity_control'),
    baseTypes: [MODEL_FLUX],
    starFlowOnly: true,
    img2imgUnsupport: true,
  },
  {
    value: 'lineart',
    label: translate('imgref_mode_lineart'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY],
    inpaintSupported: true,
  },
  {
    value: 'tile',
    label: translate('imgref_mode_tile'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
  },
  {
    value: 'scribble',
    label: translate('imgref_mode_scribble'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY],
    inpaintSupported: true,
  },
  {
    value: 'soft_edge',
    label: translate('imgref_mode_soft'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY, MODEL_FLUX],
    inpaintSupported: true,
  },
  {
    value: 'recolor',
    label: translate('imgref_mode_recolor'),
    baseTypes: [MODEL_SD15, MODEL_SDXL, MODEL_ILLUS, MODEL_PONY],
  },
  {
    value: 't2ia',
    label: translate('imgref_mode_color'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'shuffle',
    label: translate('imgref_mode_shuffle'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'normal',
    label: translate('imgref_mode_normal'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'mlsd',
    label: translate('imgref_mode_MLSD'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'reference_only',
    label: translate('imgref_mode_referenceonly'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'brightness',
    label: translate('imgref_mode_brightness'),
    baseTypes: [MODEL_SD15],
  },
  {
    value: 'segment',
    label: translate('imgref_mode_seg'),
    baseTypes: [MODEL_SD15],
  },
];

export const controlNetImgRefList = [
  {
    value: 'entity_control',
    emptyPlaceholder: translate('imgupload_placeholder_entity_control'),
  },
];

export const controlnetMap = Object.fromEntries(controlNetList.map((item) => [item.value, item]));

export const controlNetOptions = {
  reference: () => {
    return [resizeModeOption];
  },
  tile: (params, baseType) => {
    return [
      getPreprocessors('tile', baseType, '34'),
      getModels('tile', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      // 适用于TILE_RESAMPLE
      params.preprocessor === '34'
        ? {
            type: 'number',
            min: 1,
            max: 8,
            step: 1,
            defaultValue: 1,
            name: 'downSamplingRate',
            label: 'Down Sampling Rate',
          }
        : null,
      // 适用于 TILE_COLORFIX/TILE_COLORFIX_SHARP
      ['43', '44'].includes(params.preprocessor)
        ? {
            type: 'number',
            min: 3,
            max: 32,
            step: 1,
            defaultValue: 8,
            name: 'variation',
            label: 'Variation',
          }
        : null,
      // 适用于TILE_COLORFIX/TILE_COLORFIX_SHARP
      ['43', '44'].includes(params.preprocessor)
        ? {
            type: 'number',
            min: 0,
            max: 2,
            step: 1,
            defaultValue: 1,
            name: 'sharpness',
            label: 'Sharpness',
          }
        : null,
      // 适用于Blur Gaussian
      params.preprocessor === '52'
        ? {
            type: 'number',
            min: 0,
            max: 2,
            step: 1,
            defaultValue: 9,
            name: 'sigma',
            label: 'Sigma',
          }
        : null,
    ].filter(Boolean);
  },
  reference_only: () => {
    return [
      getPreprocessors('reference_only', MODEL_SD15),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      {
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01,
        defaultValue: 0.5,
        name: 'styleFidelity',
        label: 'Style Fidelity',
      },
    ].filter(Boolean);
  },
  canny: (params, baseType) => {
    return [
      getPreprocessors('canny', baseType),
      getModels('canny', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      params.preprocessor === '1'
        ? {
            type: 'number',
            min: 1,
            max: 255,
            step: 1,
            defaultValue: 100,
            name: 'lowThreshold',
            label: 'Low Threshold',
          }
        : null,
      params.preprocessor === '1'
        ? {
            type: 'number',
            min: 1,
            max: 255,
            step: 1,
            defaultValue: 100,
            name: 'highThreshold',
            label: 'High Threshold',
          }
        : null,
    ].filter(Boolean);
  },
  mlsd: (params, baseType) => {
    return [
      getPreprocessors('mlsd', baseType),
      getModels('mlsd', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      String(params.preprocessor) === '8'
        ? {
            type: 'number',
            min: 0.1,
            max: 1,
            step: 0.1,
            defaultValue: 0.1,
            name: 'valueThreshold',
            label: 'Value Threshold',
          }
        : null,
      String(params.preprocessor) === '8'
        ? {
            type: 'number',
            min: 0.1,
            max: 1,
            step: 0.1,
            defaultValue: 0.1,
            name: 'distanceThreshold',
            label: 'Distance Threshold',
          }
        : null,
    ].filter(Boolean);
  },
  lineart: (params, baseType) => {
    return [
      getPreprocessors('lineart', baseType),
      getModels('lineart', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  soft_edge: (params, baseType) => {
    return [
      getPreprocessors('soft_edge', baseType),
      getModels('soft_edge', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      // 适用于Scribble_XDOG
      params.preprocessor === '21'
        ? {
            type: 'number',
            min: 1,
            max: 64,
            step: 1,
            defaultValue: 32,
            name: 'XDOGThreshold',
            label: 'XDOG Threshold',
          }
        : null,
    ].filter(Boolean);
  },
  scribble: (params, baseType) => {
    return [
      getPreprocessors('scribble', baseType),
      getModels('scribble', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      // 适用于Softedge_teed
      params.preprocessor === '58'
        ? {
            type: 'number',
            min: 0,
            max: 10,
            step: 1,
            defaultValue: 2,
            name: 'safeSteps',
            label: 'Safe Steps',
          }
        : null,
    ].filter(Boolean);
  },
  depth: (params, baseType) => {
    return [
      getPreprocessors('depth', baseType),
      getModels('depth', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      // 适用于depth_leres/depth_leres++
      ['3', '4'].includes(params.preprocessor)
        ? {
            type: 'number',
            min: 0,
            max: 100,
            step: 1,
            defaultValue: 0,
            name: 'removeNear',
            label: 'Remove Near',
          }
        : null, // 适用于depth_leres/depth_leres++
      ['3', '4'].includes(params.preprocessor)
        ? {
            type: 'number',
            min: 0,
            max: 100,
            step: 1,
            defaultValue: 0,
            name: 'removeBackground',
            label: 'Remove Background',
          }
        : null,
    ].filter(Boolean);
  },
  segment: (params, baseType) => {
    return [
      getPreprocessors('segment', baseType),
      getModels('segment', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  normal: (params, baseType) => {
    return [
      getPreprocessors('normal', baseType),
      getModels('normal', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
      // 适用于NORMAL_MAP
      params.preprocessor === '9'
        ? {
            type: 'number',
            min: 0,
            max: 100,
            step: 0.1,
            defaultValue: 0.4,
            name: 'backgroundThreshold',
            label: 'Normal Background Threshold',
          }
        : null,
    ].filter(Boolean);
  },
  openpose: (params, baseType) => {
    return [
      getPreprocessors('openpose', baseType),
      getModels('openpose', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  t2ia: (params, baseType) => {
    return [
      getPreprocessors('t2ia', baseType),
      getModels('t2ia', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  shuffle: (params, baseType) => {
    return [
      getPreprocessors('shuffle', baseType),
      getModels('shuffle', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  ip_adapter: (params, baseType) => {
    return [
      getPreprocessors('ip_adapter', baseType),
      getModels('ip_adapter', baseType),
      controlModeOption,
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      pixelPerfectOption,
      getPreprocessorResolutionOption({ disabled: params.pixelPerfect + '' === '1' }),
    ];
  },
  brightness: (_, baseType) => {
    return [
      getPreprocessors('brightness', baseType),
      getModels('brightness', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      controlModeOption,
      resizeModeOption,
    ];
  },
  recolor: (_, baseType) => {
    return [
      getPreprocessors('recolor', baseType),
      getModels('recolor', baseType),
      controlRangeOption[0],
      controlRangeOption[1],
      resizeModeOption,
      {
        type: 'number',
        min: 0.1,
        max: 2,
        step: 0.1,
        defaultValue: 1,
        name: 'gammaCorrection',
        label: 'Gamma Correction',
      },
    ];
  },
};
